import { Directive, EventEmitter, HostListener, OnDestroy, Output, inject } from '@angular/core';
import { debounce } from '@iris/common/decorators/debounce.decorator';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';

export enum ZoomDirection {
  In = 'In', Out = 'Out',
}

@Directive({
  selector: '[irisZoom]',
  standalone: false,
})
export class IrisZoomDirective implements OnDestroy {
  private readonly hotkeysService = inject(HotkeysService);

  @Output() zoomChange = new EventEmitter<ZoomDirection>();

  @HostListener('wheel', ['$event']) onMouseWheel(event: WheelEvent): void {
    if (event.ctrlKey) {
      this.mouseWheelFunc(event);

      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }

  private readonly zoomHotkeys: Hotkey | Hotkey[];

  constructor() {
    this.zoomHotkeys = this.hotkeysService.add([
      new Hotkey('ctrl+=', (_event: KeyboardEvent): boolean => {
        this.zoomChange.emit(ZoomDirection.In);
        return false;
      }),
      new Hotkey('ctrl+-', (_event: KeyboardEvent): boolean => {
        this.zoomChange.emit(ZoomDirection.Out);
        return false;
      }),
    ]);
  }

  @debounce(100)
  mouseWheelFunc(event: WheelEvent & { wheelDelta?: number }): void {
    const delta = event.deltaY || event.detail || event.wheelDelta;
    let direction: ZoomDirection;

    if (delta > 0) {
      direction = ZoomDirection.Out;
    } else {
      direction = ZoomDirection.In;
    }

    this.zoomChange.emit(direction);
  }

  ngOnDestroy(): void {
    this.hotkeysService.remove(this.zoomHotkeys);
  }
}
